<template>
  <div class="page-header">
    <div class="column max-width-container">
      <slot name="navigation-buttons"></slot>
      <div class="header-body">
        <div class="header-item">
          <h2 class="heading-2 header-title">{{ title }}</h2>
          <div class="buttons-set"><slot name="buttons-set"></slot></div>
        </div>
        <div class="header-item">
          <div class="header-category-wrapper"><slot name="categories"></slot></div>
          <div class="date-text paragraph-s white-space-nowrap">{{ dateText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dateText: String
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.page-header {
  background-color: var(--light-gray);

  .back-navigation {
    margin: 18px 0 0;
  }

  .header-body {
    display: flex;
    flex-direction: column;
    padding: 20px 0 0 0;
    .header-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
      .date-text {
        color: var(--gray);
        white-space: nowrap;
      }
      .buttons-set {
        display: flex;
        align-items: center;
        .button:not(:last-child) {
          margin-right: 10px;
        }
      }
      .header-category-wrapper {
        display: flex;
      }
    }
  }
}
@media (max-width: $tablet) {
  .page-header {
    .header-body {
      .header-item {
        flex-direction: column;
        align-items: flex-start;
        .buttons-set {
          margin: 10px;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1;
        }
        .header-category-wrapper {
          flex-direction: column;
        }
      }
    }
  }
}
</style>
